<div
  class="discount-buy-container"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <h1>خرید بسته تخفیفی</h1>

  <div
    class="discount-type-preview"
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutAlign="space-around center"
  >
    <shared-discount
      class="discount"

      fxFlex="60"

      [preview]="true"
      [discountItem]="discountType"
    ></shared-discount>

    <img
      fxFlex="40"
      src="../../../../../assets/image/discount-package.jpg"
      alt=""
    />
  </div>
</div>

<div class="actions" mat-dialog-actions [align]="'center'">
  <button (click)="redirect() " mat-raised-button color="primary" [disabled]="!paymentRedirectUrl">
    <span> رفتن به صفحه پرداخت </span>

    <jam-icon name="credit-card"></jam-icon>
  </button>
  <button mat-dialog-close mat-button color="warn">
    <jam-icon name="close"></jam-icon>
    لغو سفارش
  </button>
</div>
